import Vue from 'vue'
import App from './App.vue'


require('./assets/spectre-0.5.1/spectre.min.css')

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
